const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.videoControl();
    },

    videoControl: function() {
        $('#myVideo').prop("controls", false);

        $('video').click(function(){
            // Toggle Magic Here
            this[this.paused ? 'play' : 'pause']();

            $('video').on('play', function() {
                //Actions when video play selected
                $('.play').hide();
                $('.pause').show();
            });

            $('video').on('pause', function() {
                //Actions when video play selected
                $('.play').show();
                $('.pause').hide();
            });
        });
	}
}

export default _this;